<template>
  <div class="LKMunMehReviewFourLevels">
    <div v-for="(level, idx) in parent.items" :key="idx" class="LKMunMehReviewFourLevels__Level">
      <FormRow
        :ref="`Row.${idx}`"
        class="LKMunMehReviewFourLevels__Level__Row"
        :idx="getIndex(idx)"
        :item="level"
        bold
        :marks-hidden="marksHidden"
      />

      <span
        v-text="getExpertThreeCommentForIndicator(level.id)"
      />

      <hr class="LkMunMehReviewForm__line">

      <v-row
        :ref="`SubIndicator.${level.id}`"
        :class="{ 'LKMunMehReviewFourLevels__Level__Selected': $route.params.targetId === level.id }"
      >
        <v-col :cols="4">
          <div class="LKMunMehReviewFourLevels__Documents">
            <template v-if="hasDocs(level)">
              <template v-for="(doc, docIdx) in getDocs(level.id).data">
                <a
                  :key="`${level.id}.DLink${docIdx}`"
                  :href="doc.link"
                  target="_blank"
                  class="link"
                  v-text="doc.link"
                />
                <div :key="`${level.id}.DComment${docIdx}`" class="comment" v-text="doc.comment" />
              </template>
            </template>
            <div v-else>
              Документы отсутствуют
            </div>
            <div class="updated-at" :class="{ 'logged': isIndicatorInLogs(level.id) }">
              {{ getDocs(level.id).updated_at | dateFormatter }}
            </div>
          </div>
        </v-col>
        <v-divider vertical class="LKMunMehReviewFourLevels__Line-vertical" />
        <v-col :cols="8">
          <v-row>
            <v-col cols="12">
              <h4
                class="LkMunMehReviewForm__content__title__header mx-0"
                v-text="'Параметры оценивания компонента'"
              />
            </v-col>
          </v-row>

          <template v-if="!isDocumentLoading">
            <v-row v-for="(value, valueIdx) in level.values" :key="`${level.id}.V${valueIdx}`">
              <v-col cols="6" style="align-self: center;">
                <div class="LKMunMehReviewFourLevels__Values">
                  <div class="name" v-text="getNameForIndicatorValue(value.id)" />
                </div>
              </v-col>
              <v-col :cols="6">
                <div class="LKMunMehReviewFourLevels__Values">
                  <v-row>
                    <v-col :cols="marksHidden ? 12 : 3" class="text-right">
                      <div class="score" v-text="value.max_score" />
                    </v-col>

                    <template v-if="!marksHidden">
                      <v-col cols="3" class="text-right">
                        <div
                          class="score"
                          v-text="getMarkForExpertOneIndicatorValue(value.id)"
                        />
                      </v-col>
                      <v-col cols="3" class="text-right">
                        <div
                          class="score"
                          v-text="getMarkForExpertTwoIndicatorValue(value.id)"
                        />
                      </v-col>
                      <v-col :cols="3" class="text-right">
                        <div
                          class="score"
                          v-text="getMarkForExpertThreeIndicatorValue(value.id)"
                        />
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-else>
            <v-row>
              <v-col cols="12">
                <LKProgressCircular
                  :size="50"
                />
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>

      <hr class="LkMunMehReviewForm__line">
    </div>
  </div>
</template>

<script>
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import FormRow from '@/views/LKMunMeh/HostView/components/LKMunMehHostViewRow.vue'

import { LKMunMehHostViewMapper as StoreMapper } from '../store'

export default {
  name: 'LKMunMehHostViewFourLevels',
  components: {
    LKProgressCircular,
    FormRow,
  },
  props: {
    parent: {
      type: Object,
      required: true,
    },
    parentIdx: {
      type: String,
      required: true,
    },
    marksHidden: Boolean,
  },
  computed: {
    ...StoreMapper.mapState(['isDocumentLoading']),
    ...StoreMapper.mapGetters([
      'getDocuments',
      'isIndicatorInLogs',
      'getNameForIndicatorValue',

      'getMarkForExpertOneIndicatorValue',
      'getMarkForExpertTwoIndicatorValue',
      'getExpertThreeCommentForIndicator',
      'getMarkForExpertThreeIndicatorValue',
    ]),
  },
  watch: {
    isDocumentLoading(v) {
      if (!v) {
        this.scrollToTarget()
      }
    },
  },
  mounted() {
    this.scrollToTarget()
  },
  methods: {
    scrollToTarget(_targetId) {
      const targetId = this.$route.params?.targetId || _targetId
      if (targetId) {
        const elements = this.$refs[`SubIndicator.${targetId}`]
        if (Array.isArray(elements) && elements.length > 0) {
          this.$nextTick(() => {
            // Почему-то scrollIntoView вызывается, но иногда не прокручивается,
            // хотя сам элемент есть в DOM
            setTimeout(() => elements[0].scrollIntoView(), 100)
          })
        }
      }
    },
    getDocs(id) {
      return this.getDocuments(id)
    },
    hasDocs(level) {
      return this.getDocs(level.id).data.length > 0
    },
    getIndex(idx) {
      return [this.parentIdx, idx].join('.')
    },
  },
}
</script>

<style lang="scss">
.LKMunMehReviewFourLevels {
  &__Level {
    &__Selected {
      background-color: $webflow-color-blue-light-2;
    }

    &__Row {
      // ..
    }
  }

  &__Documents {
    .link {
      color: $webflow-color-blue-dark;
      word-wrap: break-word; /* Internet Explorer 5.5+ */
      white-space: pre-wrap; /* CSS3 */
      white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
      white-space: -o-pre-wrap; /* Opera 7 */

      &:hover {
        color: $webflow-color-blue-dark-hover;
      }
    }

    .comment {
      font-size: 16px;
      color: $webflow-color-black;
    }

    .updated-at {
      font-size: 12px;
      font-style: italic;
      color: $webflow-color-blue-dark;
      text-align: right;
    }

    .logged {
      color: $webflow-color-red;
    }
  }

  &__Line-vertical {
    border-color: $webflow-color-alert-line !important;
  }

  &__Values {
    .row {
      align-items: center;
    }

    .name {
      font-size: 16px;
      color: $webflow-color-black;
    }

    .score {
      font-weight: bold;
    }
  }
}
</style>
